import apiClient from '../apiClient';
import { GET_CITY_GROUP_BY_ID_URL } from '../apiUrl';

const getCityGroupByIdApi = Id => {
  return apiClient.get(GET_CITY_GROUP_BY_ID_URL(Id));
};

export default getCityGroupByIdApi;
